/* ---------------------------------------------------------------------------
   EU-Gewährleistungshinweis, Dialog für die Link-Variante.
   Gehört zu snippets/eu-guarantee-notice.liquid (style: 'link').
   Delegiert am document, funktioniert also für beliebig viele Instanzen und
   auch für Inhalte, die erst nachträglich in den DOM kommen.
   Ohne JavaScript bleibt der Link ein normaler Link auf die amtliche Datei.
   --------------------------------------------------------------------------- */
document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-eu-notice-open]');

  if (opener) {
    var dialog = document.getElementById(opener.getAttribute('data-eu-notice-open'));
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    }
    return;
  }

  var file = event.target.closest('[data-eu-notice-file]');
  if (file) {
    event.preventDefault();
    window.open(file.getAttribute('data-eu-notice-file'), '_blank', 'noopener');
    return;
  }

  var closer = event.target.closest('[data-eu-notice-close]');
  if (closer) {
    var owner = closer.closest('dialog');
    if (owner) owner.close();
    return;
  }

  /* Klick auf den Backdrop schliesst den Dialog */
  if (event.target.tagName === 'DIALOG' && event.target.classList.contains('eu-notice-dialog')) {
    event.target.close();
  }
});
